// extracted by mini-css-extract-plugin
module.exports = {"fb6c143":"fb6c143","w1nyp16l":"w1nyp16l","b1btlj5u":"b1btlj5u","w15kg74w":"w15kg74w"};